import styled from '@emotion/styled';

export const Separator = styled.div`
  margin-top: 48px;
  margin-bottom: 48px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.dark['05']};
  width: 100%;
`;
